import {
  Box,
  Flex,
  Link,
  Text,
} from '@chakra-ui/react';
import { CHART_COLOURS } from '@src/modules/performance/shared/constants';
import { CircleIndicator } from '@src/modules/performance/components/indicators';
import { useDataQualityKPI } from '@src/modules/performance/context/reports-api-hooks';
import ReportHeader from './ReportHeader';

const subheader = 'Data Quality Score';
const informationSource = {
  title: 'Data Quality',
  content: [
    {
      title: 'Data Quality Score',
      description:
  <>
    <Text fontSize="inherit" mb={2}>
      The overall data quality score is an indication of the quality of available data to support investment and decision-making processes.
    </Text>
    <Text fontSize="inherit" mb={2}>
      The score is a weighted score based on the data quality metric results for the latest completed financial year. The results are weighted by the level of importance of each metric (High, moderate or low), see the score calculation link below.
    </Text>
    <Text fontSize="inherit" mb={2}>
      Further references:
      <br />
      <Link href="https://www.nzta.govt.nz/assets/Road-Efficiency-Group/docs/practice-overviews/REG-practice-overview-data-quality-framework.pdf" isExternal>Data quality framework overview</Link>
      <br />
      <Link href="https://www.nzta.govt.nz/assets/Road-Efficiency-Group/docs/practice-overviews/REG-practice-overview-data-quality-dimensions.pdf" isExternal>Data quality dimensions overview</Link>
      <br />
      <Link href="https://www.nzta.govt.nz/assets/Road-Efficiency-Group/docs/RCA-data-quality-reports/asset-management-data-quality-report-score-calculation.pdf" isExternal>Overall Asset Management Score calculation</Link>
    </Text>
  </>,
      source:
  <Text fontSize="inherit" as="span">
    Road Efficiency Group Te Ringa Maimoa annual data quality assessment and reporting undertaken within Transport Insights.
  </Text>,
    },
  ],
};

function DataQualityReportHeader({ ...rest }) {
  const { data, isLoading } = useDataQualityKPI();
  const dqScore = data?.Score;
  const lockYear = data?.LockYear;

  return (
    <ReportHeader
      title="Data Quality"
      subtitle={subheader}
      informationSource={informationSource}
      {...rest}
    >
      <Flex align="center">
        <Box mr={3}>
          <CircleIndicator
            size={60}
            colour={CHART_COLOURS.darkblue}
            value={dqScore}
            isLoading={isLoading && !data}
          />
        </Box>
        <Box pr={15}>
          <Text fontWeight="bold" color="gray" fontSize="sm">
            Data Quality Score
            <br />
            <Text as="span" fontSize="xs" color="gray">
              as at
              {' '}
              {lockYear}
            </Text>
          </Text>
        </Box>
      </Flex>
    </ReportHeader>
  );
}

export default DataQualityReportHeader;
